import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import { stringifyQueryWithoutEncoding } from 'utils/query';

export interface IWhoIsWorkingSearchQuery {
  working?: 'false' | 'true';
  group_ids?: string;
}

const fetchWhoIsWorking = (searchQuery: IWhoIsWorkingSearchQuery) => {
  const stringifiedQuery = stringifyQueryWithoutEncoding(searchQuery);
  const newEndpoints = endpoints.whoIsWorking.base + '?' + stringifiedQuery;
  return http().get(newEndpoints);
};

export function useFetchWhoIsWorking(searchQuery: IWhoIsWorkingSearchQuery, options?: any): UseQueryResult<any> {
  return useQuery({
    queryKey: ['fetchWhoIsWorking', searchQuery],
    queryFn: () => fetchWhoIsWorking(searchQuery),
    refetchInterval: 5000 * 60,
    cacheTime: 100,
    staleTime: 100,
    ...options,
  });
}
